import React, { useLayoutEffect, useRef, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ViewMore: React.FC<{ text: string; label?: string }> = ({
  text,
  label,
}) => {
  const ref = useRef<HTMLParagraphElement | null>(null);
  const [open, setOpen] = useState(false);
  const [over, setOver] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || open) {
      return undefined;
    }
    const measure = () => setOver(el.scrollHeight > el.clientHeight + 1);
    measure();
    const RO = (window as any).ResizeObserver;
    if (!RO) {
      return undefined;
    }
    const ro = new RO(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text, open]);

  return (
    <div className='psc-more'>
      <p ref={ref} className={`psc-prose${open ? '' : ' is-clamped'}`}>
        {text}
      </p>
      {(over || open) && (
        <button
          type='button'
          className='psc-more-btn'
          aria-expanded={open}
          aria-label={
            label ? `${open ? 'Show less' : 'Show more'} ${label}` : undefined
          }
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'View less' : 'View more'}
          <ExpandMoreIcon sx={{ fontSize: 12 }} />
        </button>
      )}
    </div>
  );
};

export default ViewMore;
